import { useEffect, useMemo } from 'react';
import { useCheckout } from './useCheckout';

const useInitDelivery = () => {
    const { setDeliveryMethod, setCarrier, carriers } = useCheckout();

    const isTruckDelivery = useMemo(
        () => carriers && carriers.truckDelivery.length > 0,
        [carriers],
    );

    const isVirtualDelivery = useMemo(() => carriers && carriers.virtual.length > 0, [carriers]);

    const showShippingMethods = useMemo(
        () =>
            (carriers && carriers.addressDelivery.length > 0) ||
            (carriers && carriers.dropPoint.length > 0) ||
            (carriers && carriers.clickAndCollect.length > 0),
        [carriers],
    );

    useEffect(() => {
        if (isTruckDelivery) {
            setDeliveryMethod('truckDelivery');

            if (carriers) {
                setCarrier(carriers.truckDelivery[0]);
            }
        }
    }, [isTruckDelivery]);

    useEffect(() => {
        if (isVirtualDelivery) {
            setDeliveryMethod('virtual');

            if (carriers) {
                setCarrier(carriers.virtual[0]);
            }
        }
    }, [isVirtualDelivery]);

    return {
        isTruckDelivery,
        isVirtualDelivery,
        showShippingMethods,
    };
};

export default useInitDelivery;
